import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createCookies } from './compat/cookies'
import { createAxios } from './compat/axios'
import { createAuth } from './compat/auth'
import { setRuntime } from './compat/runtime'
import { getApiBase, getApiPath } from './compat/api-base'
import { syncFavicon } from './utils/favicon'

import '@/assets/iconfont/iconfont.css'
import '@/assets/css/index.scss'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'
import '@/assets/iconfont/iconfont.js'

import '@/plugins/element-ui'
import '@/plugins/vue-swiper.js'
import '@/plugins/utils.js'
import '@/plugins/debounce.js'
import '@/plugins/main'
import '@/plugins/vue-clipboard.js'
import '@/plugins/vueqr.js'

import axiosPlugin from '@/plugins/axios'
import i18nLitePlugin from '@/plugins/i18n-lite'

Vue.config.productionTip = false

Vue.component('nuxt-link', {
  functional: true,
  render(h, ctx) {
    const data = { ...ctx.data }
    const attrs = data.attrs || {}
    const props = data.props || {}
    data.props = {
      ...props,
      to: props.to || attrs.to
    }
    return h('router-link', data, ctx.children)
  }
})

Vue.component('client-only', {
  functional: true,
  render(h, ctx) {
    return ctx.children && ctx.children.length ? ctx.children[0] : null
  }
})

Vue.component('ClientOnly', {
  functional: true,
  render(h, ctx) {
    return ctx.children && ctx.children.length ? ctx.children[0] : null
  }
})

Vue.component('no-ssr', {
  functional: true,
  render(h, ctx) {
    return ctx.children && ctx.children.length ? ctx.children[0] : null
  }
})

Vue.component('NuxtChild', {
  functional: true,
  render(h) {
    return h('router-view')
  }
})

Vue.component('nuxt', {
  functional: true,
  render(h) {
    return h('router-view')
  }
})

const cookies = createCookies()
const axios = createAxios()
const auth = createAuth({ axios, cookies, router, store })

const app = {
  router,
  store,
  $router: router,
  $store: store,
  $cookies: cookies,
  $axios: axios,
  $auth: auth
}

const inject = (name, value) => {
  app[`$${name}`] = value
  Vue.prototype[`$${name}`] = value
}

Vue.prototype.$app = app
Vue.prototype.$cookies = cookies
Vue.prototype.$axios = axios
Vue.prototype.$auth = auth
Vue.prototype.$apiBase = getApiBase()
Vue.prototype.$apiPath = getApiPath

setRuntime({ app, router, store, cookies, axios, auth })

axiosPlugin({
  redirect: location => router.push(location),
  $axios: axios,
  app
})

i18nLitePlugin({ app }, inject)

if (store._actions && store._actions.nuxtServerInit) {
  store.dispatch('nuxtServerInit', { app })
}

auth.init()
syncFavicon(cookies.get('favicon'))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
